module.exports = __webpack_public_path__ + "static/media/dashboard icon.b7d389c9.svg";